import { Children, cloneElement, forwardRef } from 'react'
import PropTypes from 'prop-types'

/**
 * @typedef {ButtonHTMLAttributes<HTMLButtonElement>} ButtonProps
 * @property {string=} action
 * @property {string=} icon
 * @property {string=} size
 * @property {string} className
 * @property {boolean=} trailing
 */

const Button = forwardRef(
  /**
   *
   * @param {ButtonProps} props
   * @returns
   */
  ({ children, action, icon, size, className, trailing, ...props }, ref) => {
    const leadingIcon = icon && !trailing
    const trailingIcon = icon && trailing
    return (
      <button
        ref={ref}
        className={`
      tw-custom-btn
      tw-custom-btn-${action} 
      tw-custom-btn-${size}
      ${className}`}
        {...props}>
        {leadingIcon && <i className={`fas fa-${icon}`} />}
        {children && (
          <span
            className={leadingIcon ? 'tw-ml-2' : trailingIcon ? 'tw-mr-2' : ''}>
            {children}
          </span>
        )}
        {trailingIcon && <i className={`fas fa-${icon}`} />}
      </button>
    )
  }
)

export default Button

Button.defaultProps = {
  action: 'default',
  size: 'normal',
  type: 'button',
}

Button.propTypes = {
  onClick: PropTypes.any,
  children: PropTypes.node,
  action: PropTypes.oneOf([
    'default',
    'primary',
    'primary-light',
    'success',
    'danger',
  ]),
  size: PropTypes.oneOf(['normal', 'medium', 'large']),
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  className: PropTypes.any,
  trailing: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
}

export function DropDownButton({ children, disabled, title }) {
  return (
    <button
      disabled={disabled}
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      title={title}
      className={`
    dropdown-toggle
    tw-custom-btn 
    tw-custom-btn-default
    tw-custom-btn-normal
    tw-custom-uppercase            
    tw-transition-all 
    tw-duration-100 
    tw-ease-linear`}>
      {children && <span>{children}</span>}
    </button>
  )
}

DropDownButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  title: PropTypes.string,
}

export function IconButton({ onClick, icon }) {
  return (
    <button
      onClick={onClick}
      className="tw-custom-button-reset tw-ml-auto tw-p-2 tw-transition-all tw-duration-100 tw-ease-linear tw-text-system-grey-300 hover:tw-text-system-grey-400">
      <i className={`fas fa-${icon}  tw-text-2xl`}></i>
    </button>
  )
}

IconButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
}

export function ButtonGroup({ children, className = '' }) {
  return (
    <div className={`tw-flex tw-flex-col tw-my-5 ${className}`}>
      {Children.map(children, child =>
        child ? cloneElement(child, { className: ['tw-mb-4'] }) : null
      )}
    </div>
  )
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
